import React, { useState, useCallback, useRef, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import FocusTrap from 'focus-trap-react';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import BurgerIcon from '@wix/da-ds/pkg/Icons/Burger';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import BurgerMenuContent from './BurgerMenuContent';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import s from './BurgerMenu.scss';
var BurgerMenu = function (_a) {
    var isModalOpen = _a.isModalOpen, isLegacyHeader = _a.isLegacyHeader, burgerButtonClassName = _a.burgerButtonClassName, activeMainMenuItem = _a.activeMainMenuItem, showUnreadIndicator = _a.showUnreadIndicator;
    var _b = useState(false), isBurgerMenuOpened = _b[0], setBurgerMenuOpened = _b[1];
    var rootRef = useRef(null);
    var isMobile = useContext(MobileContext);
    var t = useTranslation().t;
    var showBurgerMenu = useCallback(function () {
        setBurgerMenuOpened(true);
    }, []);
    var hideBurgerMenu = useCallback(function () {
        setBurgerMenuOpened(false);
    }, []);
    var toggleBurgerMenu = function () {
        return isBurgerMenuOpened ? hideBurgerMenu() : showBurgerMenu();
    };
    useOnOutsideClick(rootRef, hideBurgerMenu);
    return (React.createElement(FocusTrap, { active: isBurgerMenuOpened && !isModalOpen && !isMobile },
        React.createElement("div", { ref: rootRef, className: classnames(s['burger-menu-wrapper'], isBurgerMenuOpened && s['is-opened'], burgerButtonClassName) },
            React.createElement("div", { className: s['burger-menu-shade'], onClick: toggleBurgerMenu }),
            React.createElement("div", { className: s['burger-icon-button-wrapper'] },
                React.createElement(PlainButtonOrLink, { className: classnames(s['burger-icon-button'], showUnreadIndicator && s['has-unread']), onClick: toggleBurgerMenu, "aria-label": t('siteHeader.burger.a11y'), "aria-expanded": isBurgerMenuOpened, biData: {
                        evid: BiEventType.NETWORK_BAR_MENU_ICON,
                        is_expanding: isBurgerMenuOpened ? 0 : 1,
                        indicator: showUnreadIndicator ? 1 : 0,
                    } },
                    React.createElement(BurgerIcon, { className: s['burger-icon'], disableDefaultColors: true }))),
            React.createElement(BurgerMenuContent, { isOpen: isBurgerMenuOpened, className: s['burger-menu'], isLegacyHeader: isLegacyHeader, activeMainMenuItem: activeMainMenuItem }))));
};
export default BurgerMenu;
//# sourceMappingURL=BurgerMenu.js.map